import { Response } from '@playbooks/core/src/interfaces'
import { BaseNode } from '../../../actionCard'

export class ResponseNode extends BaseNode {
  declare data: Response

  public getLabelTemplate(): string {
    return this.data.answer
  }

  public getIsChecked(): boolean {
    return this.data.checked
  }

  public setIsChecked(value: boolean): void {
    this.data.checked = value
  }
}
